import { useEffect, useState } from "react";

import express from "../assets/uspsexpress.svg";
import priority from "../assets/uspspriority.svg";
import first from "../assets/groundadvantage.svg";
import upslogo from "../assets/ups.svg";

const normalizeUpsName = (name = "") =>
  name.replace(/®/g, "").replace(/\s+/g, " ").trim().toLowerCase();

const classifyUpsService = (name = "") => {
  const normalized = normalizeUpsName(name);
  if (normalized.includes("next day air")) {
    return "UPS Next Day Air";
  }
  if (normalized.includes("2nd day air") || normalized.includes("second day air")) {
    return "UPS 2nd Day Air";
  }
  if (normalized.includes("3 day select")) {
    return "UPS 3 Day Select";
  }
  if (normalized.includes("ground")) {
    return "UPS Ground";
  }
  return null;
};

const isSameCalendarDay = (a, b) =>
  a.getFullYear() === b.getFullYear() &&
  a.getMonth() === b.getMonth() &&
  a.getDate() === b.getDate();

const parseUpsDate = (value) => {
  if (!value || typeof value !== "string") {
    return null;
  }

  if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
    const [year, month, day] = value.split("-").map(Number);
    return new Date(year, month - 1, day);
  }

  if (/^\d{8}$/.test(value)) {
    const year = Number(value.substring(0, 4));
    const month = Number(value.substring(4, 6));
    const day = Number(value.substring(6, 8));
    return new Date(year, month - 1, day);
  }

  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) {
    return null;
  }
  return parsed;
};

const parseUspsDate = (value) => {
  if (!value || typeof value !== "string") {
    return null;
  }

  if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
    const [year, month, day] = value.split("-").map(Number);
    return new Date(year, month - 1, day);
  }

  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) {
    return null;
  }
  return parsed;
};

const isGroundAdvantageService = (service = "") =>
  service.includes("First-Class Mail") || service.includes("Ground Advantage");

const DayForecast = (props) => {
  const today = new Date();
  const [matched, setMatched] = useState(false);

  const [service, setService] = useState([]);

  const weekday = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];

  const day = weekday[today.getDay() + props.day];

  const membership = props.user?.membership;

  const [upsService, setUpsService] = useState([]);

  useEffect(() => {
    setMatched(false);
    setService([]);
    setUpsService([]);

    const services = Array.isArray(props.services) ? props.services : [];
    const ups = Array.isArray(props.ups) ? props.ups : [];

    if (services.length > 0) {
      services.forEach((service) => {
        const date = parseUspsDate(service.deliveryDate);
        if (date && isSameCalendarDay(date, props.date)) {
          setMatched(true);
          setService((prev) => [...prev, service.service]);
        }
      });
    }

    if (ups.length > 0) {
      ups.forEach((service) => {
        const date = parseUpsDate(
          service?.EstimatedArrival?.Arrival?.Date || service?.deliveryDate
        );
        const serviceName = classifyUpsService(
          service?.Service?.Description || service?.service || ""
        );

        if (
          date &&
          serviceName &&
          isSameCalendarDay(date, props.date) &&
          !Number.isNaN(date.getTime())
        ) {
          setUpsService((prev) =>
            prev.includes(serviceName) ? prev : [...prev, serviceName]
          );
        }
      });
    }
  }, [props.services, props.ups, props.date]);

  return (
    <div className="flex flex-col items-center relative">
      <div className="flex absolute top-[-2.5rem] items-center h-10">
        {service.includes("Priority Mail Express") && (
          <img className="w-14 " src={express} />
        )}

        {service.includes("Priority Mail") && (
          <img className="w-14  " src={priority} />
        )}
        {isGroundAdvantageService(service.join(" ")) && (
          <img className="w-14" src={first} />
        )}
      </div>
      <div
        className={`min-w-max flex flex-col justify-center items-center border border-4 p-2 border-white 
      ${
        matched &&
        service.includes("Priority Mail") &&
        `border-4 border !border-indigo-300 p-2`
      }

      ${
        matched &&
        isGroundAdvantageService(service.join(" ")) &&
        `border-4 border !border-indigo-100 p-2`
      } ${
          matched &&
          service.includes("Priority Mail Express") &&
          `border-4 border !border-indigo-400 p-2 `
        }
        `}
      >
        <h2 className="text-2xl font-bold text-sky-900">{day}</h2>
        <img
          className="m-2"
          src={`https://openweathermap.org/img/wn/${props.icon}.png`}
          alt="weather icon"
        />
        <h3 className="text-sky-900 m-1 font-semibold opacity-75 text-lg">
          High:{" "}
          {props.tempUnit ? (
            <span>{Math.round((props.high * 10) / 10)} °F</span>
          ) : (
            <span>{Math.round(((props.high - 32) * 5) / 9)} °C</span>
          )}
        </h3>
        <h3 className="text-sky-900 font-semibold opacity-75 text-lg">
          Low:{" "}
          {props.tempUnit ? (
            <span>{Math.round((props.low * 10) / 10)} °F</span>
          ) : (
            <span>{Math.round(((props.low - 32) * 5) / 9)} °C</span>
          )}
        </h3>
      </div>
      <div className="flex absolute bottom-[-2.6rem] items-center h-10">
        {membership && upsService.includes("UPS Next Day Air") && (
          <div className="flex items-center">
            <img className="h-8" src={upslogo} />
            <p className=" ml-2 italic font-semibold text-sm tracking-wide antialiased">
              Next Day Air
            </p>
          </div>
        )}
        {membership && upsService.includes("UPS 2nd Day Air") && (
          <div className="flex items-center">
            <img className="h-8" src={upslogo} />
            <p className=" ml-2  italic font-semibold text-sm tracking-wide antialiased">
              2nd Day Air
            </p>
          </div>
        )}
        {membership && upsService.includes("UPS 3 Day Select") && (
          <div className="flex items-center">
            <img className="h-8" src={upslogo} />
            <p className="ml-2  italic font-semibold text-sm tracking-wide antialiased">
              3 Day Select
            </p>
          </div>
        )}
        {membership && upsService.includes("UPS Ground") && (
          <div className="flex items-center">
            <img className="h-8" src={upslogo} />
            <p className=" ml-2 italic font-semibold text-sm tracking-wide antialiased">
              Ground
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default DayForecast;
